import { atom } from "recoil"
import { Maintenance } from "src/types/maintenanceUpdate/Maintenance"

export const maintenanceState = atom<Maintenance | undefined>({
  key: "atoms/maintenance/maintenanceState",
  default: undefined,
})
